// extracted by mini-css-extract-plugin
export var arrow = "Modal-module--arrow--f4de7";
export var arrowNo = "Modal-module--arrow_no--c8fe5";
export var arrowYes = "Modal-module--arrow_yes--18ec9";
export var close = "Modal-module--close--5f104";
export var flex = "Modal-module--flex--caeaf";
export var flex1 = "Modal-module--flex_1--38d63";
export var flexCenter = "Modal-module--flex_center--35939";
export var flexCenterCol = "Modal-module--flex_center_col--60515";
export var flexCol = "Modal-module--flex_col--e5811";
export var flexFixCenterCol = "Modal-module--flex_fix_center_col--5661f";
export var flexFixedCenterCol = "Modal-module--flex_fixed_center_col--e2957";
export var padding = "Modal-module--padding--11d9c";
export var rotating = "Modal-module--rotating--c199b";
export var wrapper = "Modal-module--wrapper--062cb";